import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import DiscussionPage from 'flarum/forum/components/DiscussionPage';

// Core show() sets the browser title to the discussion title; prefer the
// fof/seo per-thread title (seoMeta is included on the discussion endpoint).
app.initializers.add('noriods-seo-title', () => {
  extend(DiscussionPage.prototype, 'show', function (_, discussion) {
    const title = discussion.seoMeta?.()?.title?.();
    if (title) app.setTitle(title);
  });
});